module.exports = __webpack_public_path__ + "img/icon-app-etc.76169a65.svg";